import {
	Component,
	resource,
	input,
	signal,
	computed,
	inject,
} from "@angular/core"
import { sumByProp, to2Didigts, uniqueArr } from "@app/helpers"
import { TableWrapComponent, SpinOrContent } from "@app/utils/utils.component"
import { Row } from "./row"
import { columns } from "./common"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ApiService } from "@app/services/api.service"

const minutesToHI = (minutes: number) =>
	`${to2Didigts(Math.floor(minutes / 60))}:${to2Didigts(minutes % 60)}`

const withSubtotals = (rows: any[]) =>
	uniqueArr(rows.map(({ date }) => date))
		.map((date) => {
			const filtered = rows.filter((row) => row.date === date)
			return [
				{
					date,
					isSubTotal: true,
					name: filtered.length,
					total_hours_logged: sumByProp(filtered, "total_hours_logged"),
					average_time_logged: sumByProp(filtered, "average_time_logged"),
					count_logs: sumByProp(filtered, "count_logs"),
				},
				...filtered,
			]
		})
		.flat()

const roundTimes = (rows: any[]) =>
	rows.map((row) => ({
		...row,
		total_hours_logged: Math.round(row.total_hours_logged),
		average_time_logged: Math.round(row.average_time_logged),
	}))

const normalizeTimes = (rows: any[]) =>
	rows.map((row) => ({
		...row,
		total_hours_logged: minutesToHI(row.total_hours_logged),
		average_time_logged: minutesToHI(row.average_time_logged),
	}))

@Component({
	selector: "app-activity-log-table",
	imports: [COMMON_IMPORTS, TableWrapComponent, Row, SpinOrContent],
	template: ` <app-spin-or-content [isSpin]="rowsData.isLoading()">
		<app-table-wrap
			fieldsStr="date,user,id,owner,total_hours_logged,average_time_logged,count_logs"
		>
			@for (row of rows(); track row) {
				@if (row?.isSubTotal) {
					<tr
						class="subtotal pointer"
						(click)="toggleOpen(row.date)"
					>
						@for (field of fields; track field) {
							<td>{{ row[field] }}</td>
						}
					</tr>
				} @else if (isAllOpened() || row.date == openedDate()) {
					<tr
						row
						[row]="row"
						[user_id]="user_id()"
					></tr>
				}
			}</app-table-wrap
	></app-spin-or-content>`,
})
export class LogTable {
	apiService = inject(ApiService)
	fields = columns

	period = input("daily")
	user_id = input(0)
	isAllOpened = input(true)
	openedDate = signal<string | null>(null)

	rowsData = resource({
		params: () => ({
			period: this.period(),
			user_id: this.user_id(),
		}),
		loader: ({ params }) => this.apiService.post("get_activity", params),
	})
	rows = computed(() => {
		if (!this.rowsData.hasValue()) {
			return []
		}
		const rows = roundTimes(this.rowsData.value())
		return normalizeTimes(this.user_id() ? rows : withSubtotals(rows))
	})

	toggleOpen(date: any) {
		this.openedDate.update((value) => (date == value ? null : date))
	}
}
